import React, { useEffect, useState, useCallback } from "react";
import UserForm from "./UserForm";
import ObjectList from "../../Common/ObjectList";
import ObjectListMobile from "../../Common/ObjectListMobile";
import http from "../../Common/RestAPIHandler";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { formatDateTime } from "../../Common/Utility";
import IconButton from "@material-ui/core/IconButton";
import PhoneIcon from "@material-ui/icons/Phone";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { makeStyles } from "@material-ui/core/styles";
import PageviewIcon from '@material-ui/icons/Pageview';
import BlockIcon from '@material-ui/icons/Block';
import { Tooltip } from "@material-ui/core";
import {userManagement} from "../../Common/Languages";

const useStyles = makeStyles((theme) => ({
  button: {
    height: 30,
    width: 30,
    background: theme.colorScheme,
    color: "white",
    margin: 1,
  }
}));


const TenantUsers = (props) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loadData, setLoadData] = useState(false);

  const url = `tenant_users`;
  const actions = {
    delete: true,
    importCSV: false,
    exportCSV: false,
    exportPDF: false,
  };

  const lang = localStorage.getItem("languages");
  
  const tableColumns = [
    {
      id: "profile_image_src",
      label: "",
      minWidth: 60,
      maxWidth: 60,
      width: 60,
      sortable: false,
    },
    {
      id: "name",
      label: userManagement.NAME[lang],
      minWidth: 200,
      sortable: true,
    },
    {
      id: "roles",
      label: userManagement.ROLES[lang],
      minWidth: 175,
      sortable: true,
    },
    {
      id: "email",
      label: userManagement.EMAIL[lang],
      minWidth: 175,
      sortable: true,
    },
    {
      id: "last_login",
      label: userManagement.LASTLOGIN[lang],
      minWidth: 175,
      sortable: true,
    },
    {
      id: "status",
      label: "",
      minWidth: 20,
      sortable: true,
    },
  ];

  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        var tenantUserList = [];
        data.forEach((tenantUser) => {
          // Create name field for display
          tenantUser["name"] = `${tenantUser.first_name} ${tenantUser.last_name}`;
           
          // Process profile image - render as actual image or show placeholder
          if (tenantUser.profile_image_src) {
            tenantUser["profile_image_src"] = (
              <img
                src={tenantUser.profile_image_src}
                alt="Profile"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            );
          } else {
            tenantUser["profile_image_src"] = (
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  color: '#666'
                }}
              >
                {tenantUser.first_name?.[0]?.toUpperCase() || '?'}
              </div>
            );
          }
           
          tenantUser["status"] =
          <>
            {tenantUser["is_tenant_admin"] ? (
              <Tooltip title={userManagement?.TenantAdmin?.[lang] || "Tenant Admin"}><SupervisorAccountIcon /></Tooltip>
            ) : (
              ""
            )}
            {tenantUser["is_readonly"] ? (
              <Tooltip title={userManagement?.Readonly?.[lang] || "Readonly"}><PageviewIcon/></Tooltip>
            ) : (
              ""
            )}
            {tenantUser.has_access === false ? (
              <Tooltip title={userManagement?.Blocked?.[lang] || "Blocked"}><BlockIcon/></Tooltip>
            ) : (
              ""
            )}
          </>;
          
          tenantUser["last_login"] = formatDateTime(tenantUser["last_login"]);
          tenantUser["mobile_view_button"] = (
            <>
            {tenantUser.mobile &&
              <IconButton
                disableTouchRipple
                className={classes.button}
                edge="start"
                href={`tel://${tenantUser.mobile}`}
              >
                <PhoneIcon fontSize="small" />
              </IconButton>
            }
            {tenantUser.email &&            
              <IconButton
                className={classes.button}
                href={`mailto:${tenantUser.email}`}
              >
                <MailOutlineIcon fontSize="small" />
              </IconButton>
            }
            </>
          );
          tenantUserList.push(tenantUser);
        });
        setData(tenantUserList);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, [url, props.user.tenant, classes.button, lang]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
    {!props.mobile &&      
      <ObjectList
        {...props}
        moduleName={userManagement.TenantUsers[lang]}
        url={url}
        actions={actions}
        permissions={{
          create: ["Manage Users"],
          edit: ["Manage Users"],
          delete: ["Manage Users"],
        }}
        noAdd = {(data.length>=(props.user.user_addons+props.user.readonly_addons)) ? "allow":null}
        objectForm={UserForm}
        tableColumns={tableColumns}
        searchFields={["name"]}
        orderBy={"name"}
        data={data}
        fetchData={fetchData}
        pageHeader={(props.user.company_name || "") + " | " + userManagement.TenantUsers[lang]}
        loadData={loadData}
      />
    }
    {props.mobile &&      
      <ObjectListMobile
        {...props}
        moduleName={"Tenant Users"}
        url={url}
        actions={actions}
        permissions={{
          create: ["Manage Users"],
          edit: ["Manage Users"],
          delete: ["Manage Users"],
        }}
        noAdd = {(data.length>=(props.user.user_addons+props.user.readonly_addons)) ? "allow":null}
        objectForm={(data.length>=(props.user.user_addons+props.user.readonly_addons)) ? null : UserForm}
        tableColumns={tableColumns}
        searchFields={["name"]}
        orderBy={"name"}
        data={data}
        fetchData={fetchData}
        pageHeader={(props.user.company_name || "") + " | Tenant Users"}
        loadData={loadData}
      />
    }
    </>
  );
};

export default TenantUsers;
